import { Field } from "@kanda-libs/ks-component-ts";
import type { FunctionComponent } from "react";

const DirectorAddressForm: FunctionComponent = function ({}) {
  return (
    <div>
      <Field.Input
        name="director_info.home_address.building_name"
        label="Building name"
      />
      <Field.Input
        name="director_info.home_address.building_number"
        label="Building number"
      />
      <Field.Input name="director_info.home_address.line_1" label="Line 1" />
      <Field.Input name="director_info.home_address.line_2" label="Line 2" />
      <Field.Input name="director_info.home_address.city" label="City" />
      <Field.Input
        name="director_info.home_address.postcode"
        label="Postcode"
      />
    </div>
  );
};

export default DirectorAddressForm;
